<template>
  <div class="admin-menus">
    <header-title title="Gestión Menús"></header-title>
    <div class="product-btn">
      <v-btn
        dense
        outlined
        @click="openMenuDialog('addMenu')"
        :style="adminNavigationBackTheme"
      >
        + Nuevo
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            label="Buscar"
            v-model="search"
            class="select-box"
            outlined
            dense
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="menuGroup"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.menu_image`]="{ item }">
            <div v-if="isHomeVersionPremium" class="menu-image">
              <img
                v-if="item.menu_image"
                :src="showImageOrFallbackImage(item.menu_image)"
                @error="item.menu_image = fallbackImage"
                :alt="item.menu_image"
              />
              <img v-else :src="fallbackImage" :alt="item.name" />
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            <div class="price-quantity-item">
              <v-btn
                rounded
                dark
                :x-small="true"
                class="base-quantity-info"
                :style="{ 'background-color': '#000' }"
              >
                {{ formatPrice(item.price) }}
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.isDrink`]="{ item }">
            <span>
              {{ item.isDrink ? "Si" : "No" }}
            </span>
          </template>
          <template v-slot:[`item.isDessert`]="{ item }">
            <span>
              {{ item.isDessert ? "Si" : "No" }}
            </span>
          </template>
          <template v-slot:[`item.isStarter`]="{ item }">
            <span>
              {{ item.isStarter ? "Si" : "No" }}
            </span>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <div style="display:flex;">
              <v-switch
                v-model="item.active"
                @change="updateActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openMenuDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <MenuGroupDialog ref="menuGroupDialog"></MenuGroupDialog>
  </div>
</template>

<script>
import { menuGroupCollection, updateMenuGroup } from "@/collections/menuGroup";
import MenuGroupDialog from "../../../components/admin/menugroup/MenuGroupDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { MenuGroupTableHeader } from "@/utils/tableHeaderconstants";
import { saveUiMenuOrder } from "@/collections/uiMenuOrder";

export default {
  name: "menu-group",
  components: {
    MenuGroupDialog,
    HeaderTitle
  },
  data() {
    return {
      search: "",
      headers: [...MenuGroupTableHeader],
      menuGroup: []
    };
  },
  firestore() {
    return {
      menuGroup: menuGroupCollection
    };
  },
  methods: {
    async updateActive(value, menu) {
      try {
        await updateMenuGroup(menu.id, { active: value });
        await saveUiMenuOrder(menu.id, {
          ...menu,
          id: menu.id,
          type: "menu_group",
          sort: 1000
        });
      } catch (error) {
        this.setlogError(
          "update_menu_group/save_ui_menu_order",
          "Obtained error message in updateActive()",
          error.stack,
          this.$options.name
        );
      }
    },
    openMenuDialog(id) {
      this.$refs.menuGroupDialog.open(id);
    }
  }
};
</script>

<style scoped>
.left-border {
  border-left: 1px solid !important;
}
</style>
